import { registerPlugin } from '@capacitor/core'

const SumUpPlugin = registerPlugin<any>('SumUpPlugin')

export { SumUpPlugin }
